import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BlogEditor = () => {
  const [blogs, setBlogs] = useState([]);
  const [selectedBlogId, setSelectedBlogId] = useState('');
  const [image, setImage] = useState(null);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [contentBlocks, setContentBlocks] = useState(['', '', '']);
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';
        const res = await axios.get(`${serverBaseUrl}/api/blogs`);
        setBlogs(res.data);
      } catch (error) {
        console.error('Помилка завантаження блогів:', error);
      }
    };
    fetchBlogs();
  }, []);

  useEffect(() => {
    if (selectedBlogId) {
      const fetchBlogAndCard = async () => {
        try {
          const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';
          const blogRes = await axios.get(`${serverBaseUrl}/api/blogs/${selectedBlogId}`);
          const cardRes = await axios.get(`${serverBaseUrl}/api/blogs/cards/${selectedBlogId}`);
          
          const blog = blogRes.data;
          const card = cardRes.data;

          setTitle(blog.title);
          setContentBlocks(blog.contentBlocks);
          setDescription(card.description.replace('...', ''));
        } catch (error) {
          console.error('Помилка завантаження даних блогу:', error);
        }
      };
      fetchBlogAndCard();
    }
  }, [selectedBlogId]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setImage(file);
    } else {
      setNotification('Будь ласка, виберіть файл зображення (SVG, PNG, JPG тощо)');
      setImage(null);
      setTimeout(() => setNotification(null), 3000);
    }
  };

  const handleContentChange = (index) => (e) => {
    const newBlocks = [...contentBlocks];
    newBlocks[index] = e.target.value;
    setContentBlocks(newBlocks);
  };

  const uploadImageToCloudinary = async () => {
    if (!image) return null;
    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'ml_default');

    try {
      const res = await axios.post(
        'https://api.cloudinary.com/v1_1/dca5poo9m/image/upload',
        formData
      );
      return res.data.secure_url;
    } catch (error) {
      console.error('Помилка завантаження картинки:', error);
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedBlogId) {
      setNotification('Будь ласка, виберіть блог для редагування');
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    const imageUrl = await uploadImageToCloudinary();
    const updatedData = {
      title,
      description: description.slice(0, -3) + '...',
      contentBlocks,
      imageUrl: imageUrl || undefined,
    };

    try {
      const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';
      await axios.put(`${serverBaseUrl}/api/blogs/${selectedBlogId}`, updatedData);
      setNotification(`Блог та картка з ID ${selectedBlogId} успішно оновлені`);
      setTimeout(() => setNotification(null), 3000);

      setImage(null);
      setTitle('');
      setDescription('');
      setContentBlocks(['', '', '']);
      setSelectedBlogId('');
      document.querySelector('input[type="file"]').value = '';
    } catch (error) {
      console.error('Помилка оновлення блогу:', error);
      setNotification('Помилка при оновленні блогу');
      setTimeout(() => setNotification(null), 3000);
    }
  };

  return (
    <div className="blog-editor">
      <h2>Редагувати блог</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Виберіть блог:</label>
          <select
            value={selectedBlogId}
            onChange={(e) => setSelectedBlogId(e.target.value)}
            required
          >
            <option value="">-- Виберіть блог --</option>
            {blogs.map((blog) => (
              <option key={blog._id} value={blog._id}>
                {blog.title}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Нова картинка (SVG, PNG, JPG тощо):</label>
          <input type="file" accept="image/*" onChange={handleImageChange} />
        </div>
        <div className="form-group">
          <label>Заголовок:</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Короткий опис (для картки):</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows="3"
            required
          />
        </div>
        {contentBlocks.map((block, index) => (
          <div className="form-group" key={index}>
            <label>{`Текстовий блок ${index + 1}:`}</label>
            <textarea
              value={block}
              onChange={handleContentChange(index)}
              rows="5"
              required
            />
          </div>
        ))}
        <button type="submit">Оновити блог</button>
      </form>
      {notification && <div className="notification">{notification}</div>}
    </div>
  );
};

export default BlogEditor;